<script setup lang="ts">
import type { Post } from '@/blog/domain/Post';
import { DeepReadonly } from 'vue';

interface Props {
  post: DeepReadonly<Post>
}

const props = defineProps<Props>();
</script>

<template>
  <article
    class="w-[17rem] bg-white rounded-xl shadow-md overflow-hidden flex flex-col"
  >
    <div class="h-32 w-full overflow-hidden">
      <img
        v-if="props.post.imageUrl"
        :src="props.post.imageUrl"
        :alt="props.post.title"
        class="h-full w-full object-cover"
      />
    </div>

    <div class="p-4 flex flex-col flex-grow">
      <h3 class="text-base font-semibold text-blue-500 tracking-wide">
        {{ props.post.title }}
      </h3>

      <p class="mt-2 text-sm text-black line-clamp-3" v-html="props.post.excerpt" />
      <div class="mt-auto">
        <div class="mt-4">
          <a :href="`/${props.post.slug}`" class="px-4 py-2 bg-blue-900 text-white text-xs rounded-full font-bold hover:bg-blue-800">
            Read More
          </a>
        </div>
        <div class="h-1 mt-4 mb-2 bg-gray-200 w-full flex-shrink-0" />
        <p class="text-sm font-light text-gray-600 flex-shrink-0">
          {{ props.post.formattedDate }}
        </p>
      </div>
    </div>
  </article>
</template>
